<div class="main">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="pr-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="pr-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()" aria-label="Go back to Purchase Requests">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to Purchase Requests
                </button>
                <h3>{{ prDetails?.prNumber || prNumber }}</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="pr-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + AppConstants.ROUTES.APPROVED_PRS]" class="pr-header-title breadcrumb-link">Purchase Requests <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span> Purchase Request Details</span>
                </span>
            </div>
            <div class="d-flex align-items-center gap-3">
                <button class="export-pdf-btn rounded-pill text-white" (click)="openDocumentsDialog()" aria-label="View Documents">
                    <i class="fas fa-paperclip me-2"></i>
                    Documents
                </button>
                <button class="export-pdf-btn rounded-pill text-white" (click)="exportPDF()" aria-label="Export PDF">
                    <i class="fas fa-download me-2"></i>
                    Export PDF
                </button>
            </div>
        </div>

        <!-- Main Content Card -->
        <div class="mandatory-application m-4" *ngIf="prDetails">
            <div class="inside-out p-4">
                <div class="mandatory-fields"></div>
                <div class="container pt-4">
                    <div class="tc-status-panel" [class.tc-active]="prDetails.isTC">
                        <div>
                            <span class="tc-status-label">TC Required</span>
                            <strong>{{ prDetails.isTC ? 'Yes - FWA-Practice/Tender Rules Apply' : 'No - Standard Practice Flow' }}</strong>
                        </div>
                        <label class="tc-status-toggle tc-switch">
                            <span class="switch-label">TC REQUIRED</span>
                            <input type="checkbox" [checked]="prDetails.isTC" (change)="updateTCFlag($any($event.target).checked)">
                            <span class="switch-track" aria-hidden="true"><span class="switch-thumb"></span></span>
                        </label>
                    </div>
                    <!-- Purchase Request Details Section -->
                    <fieldset class="content-fieldset mb-4">
                        <legend class="section-legend">Purchase Request Details</legend>
                        <div class="pr-info-section">
                            <div class="pr-info-grid">
                                <div class="info-item">
                                    <label class="info-label">PR Number</label>
                                    <p class="info-value">{{ prDetails.prNumber }}</p>
                                </div>
                                <div class="info-item">
                                    <label class="info-label">PR Name</label>
                                    <p class="info-value">{{ prDetails.prName || 'N/A' }}</p>
                                </div>
                                <div class="info-item d-none">
                                    <label class="info-label">Department</label>
                                    <p class="info-value">{{ prDetails.department }}</p>
                                </div>
                                <div class="info-item">
                                    <label class="info-label">Requisition Purpose</label>
                                    <p class="info-value">{{ prDetails.requisitionPurpose }}</p>
                                </div>
                                <div class="info-item">
                                    <label class="info-label">Value (QAR)</label>
                                    <p class="info-value">{{ prDetails.value | number: '1.2-2' }}</p>
                                </div>
<div class="info-item">
                                    <label class="info-label">Request Date</label>
                                    <p class="info-value">{{ prDetails.requestDate | date: 'yyyy-MM-dd' }}</p>
                                </div>
                                <div class="info-item" *ngIf="prDetails.transactionDate">
                                    <label class="info-label">Transaction Date</label>
                                    <p class="info-value">{{ prDetails.transactionDate | date: 'yyyy-MM-dd' }}</p>
                                </div>
                                <div class="info-item">
                                    <label class="info-label">Approved Date</label>
                                    <p class="info-value">{{ prDetails.approvedDate | date: 'yyyy-MM-dd' }}</p>
                                </div>
                                <div class="info-item">
                                    <label class="info-label">Requestor</label>
                                    <p class="info-value">{{ prDetails.requestor }}</p>
                                </div>
                                <div class="info-item" *ngIf="prDetails.submittedBy">
                                    <label class="info-label">Submitted By</label>
                                    <p class="info-value">{{ prDetails.submittedBy }}</p>
                                </div>
                                <div class="info-item">
                                    <label class="info-label">Status</label>
                                    <div class="d-flex align-items-center gap-2">
                                        <app-status-badge 
                                            [text]="prDetails.status"
                                            [color]="getStatusColor(prDetails.status)"
                                            [size]="'small'">
                                        </app-status-badge>
                                    </div>
                                </div>
                                <div class="info-item full-width" *ngIf="prDetails.description">
                                    <label class="info-label">Description</label>
                                    <p class="info-value">{{ prDetails.description }}</p>
                                </div>
                                <div class="info-item full-width" *ngIf="prDetails.justification">
                                    <label class="info-label">Justification</label>
                                    <p class="info-value">{{ prDetails.justification }}</p>
                                </div>
                                <div class="info-item full-width" *ngIf="prDetails.specifications && prDetails.specifications.length > 0">
                                    <label class="info-label">Specifications</label>
                                    <ul class="specifications-list">
                                        <li *ngFor="let spec of prDetails.specifications">{{ spec }}</li>
                                    </ul>
                                </div>
                                <div class="info-item full-width" *ngIf="prDetails.linkedTender">
                                    <label class="info-label">Linked Tender</label>
                                    <p class="info-value">
                                        <a (click)="viewTender(prDetails.linkedTender)" class="tender-link">{{ prDetails.linkedTender }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <!-- Evaluation Criteria Section -->
                    <fieldset class="content-fieldset mb-4" *ngIf="evaluationCriteria && (evaluationCriteria.evaluationType || evaluationCriteria.technicalWeightage || evaluationCriteria.commercialWeightage)">
                        <legend class="section-legend">Evaluation Criteria</legend>
                        <div class="evaluation-criteria-section">
                            <div class="row mb-3">
                                <div class="col-md-4">
                                    <div class="info-item mb-3">
                                        <p class="fw-bold mb-1">Evaluation Type:</p>
                                        <p class="light-text-m">{{ evaluationCriteria.evaluationType || 'N/A' }}</p>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="info-item mb-3">
                                        <p class="fw-bold mb-1">Technical Weightage:</p>
                                        <p class="light-text-m">{{ evaluationCriteria.technicalWeightage | number: '1.2-2' }}%</p>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="info-item mb-3">
                                        <p class="fw-bold mb-1">Commercial Weightage:</p>
                                        <p class="light-text-m">{{ evaluationCriteria.commercialWeightage | number: '1.2-2' }}%</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Technical Evaluation Criteria -->
                            <div class="mb-4" *ngIf="evaluationCriteria.technicalEvaluationCriteria && evaluationCriteria.technicalEvaluationCriteria.length > 0">
                                <h5 class="fw-bold mb-3">Technical Evaluation Criteria</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Description</th>
                                                <th style="width: 150px;">Weightage</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let criteria of evaluationCriteria.technicalEvaluationCriteria">
                                                <td>{{ criteria.description || criteria.Description }}</td>
                                                <td>{{ (criteria.weightage || criteria.Weightage) | number: '1.2-2' }}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- Commercial Evaluation Criteria -->
                            <div class="mb-4" *ngIf="evaluationCriteria.commercialEvaluationCriteria && evaluationCriteria.commercialEvaluationCriteria.length > 0">
                                <h5 class="fw-bold mb-3">Commercial Evaluation Criteria</h5>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Description</th>
                                                <th style="width: 150px;">Weightage</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let criteria of evaluationCriteria.commercialEvaluationCriteria">
                                                <td>{{ criteria.description || criteria.Description }}</td>
                                                <td>{{ (criteria.weightage || criteria.Weightage) | number: '1.2-2' }}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <!-- PR Lines -->
                    <fieldset class="content-fieldset mb-4">
                        <legend class="section-legend">All Lines for This PR</legend>
                        <div class="all-bids-header d-flex justify-content-between align-items-center mb-3">
                            <h5 class="all-bids-title mb-0"></h5>
                            <div class="total-bids-count">
                                Total PR Lines: <strong>{{ this.prDetails?.lines?.length }}</strong>
                            </div>
                        </div>
                        <div class="bids-table-container">
                            <app-data-table [data]="this.prDetails?.lines || []" [columns]="tableColumns" [paginator]="true">
                            </app-data-table>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>

    <!-- Documents Dialog -->
    <div class="documents-dialog-overlay" *ngIf="showDocumentsDialog" (click)="closeDocumentsDialog()">
        <div class="documents-dialog" (click)="$event.stopPropagation()">
            <!-- Header -->
            <div class="dialog-header">
                <div class="header-content">
                    <h3 class="dialog-title">PR Documents</h3>
                    <p class="dialog-subtitle" *ngIf="prDetails">{{ prDetails.prNumber }}</p>
                </div>
                <button class="close-btn" (click)="closeDocumentsDialog()" aria-label="Close">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>

            <!-- Content -->
            <div class="dialog-content">
                <div class="documents-list" *ngIf="prDetails && prDetails.documents && prDetails.documents.length > 0">
                    <div *ngFor="let document of prDetails.documents" class="document-item">
                        <div class="document-icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4987 1.66667H4.9987C4.55667 1.66667 4.13275 1.84226 3.82019 2.15482C3.50763 2.46738 3.33203 2.89131 3.33203 3.33333V16.6667C3.33203 17.1087 3.50763 17.5326 3.82019 17.8452C4.13275 18.1577 4.55667 18.3333 4.9987 18.3333H14.9987C15.4407 18.3333 15.8646 18.1577 16.1772 17.8452C16.4898 17.5326 16.6654 17.1087 16.6654 16.6667V5.83333L12.4987 1.66667Z" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.668 1.66667V5C11.668 5.44203 11.8436 5.86595 12.1561 6.17851C12.4687 6.49107 12.8926 6.66667 13.3346 6.66667H16.668" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.33464 7.5H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.3346 10.8333H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.3346 14.1667H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="document-info">
                            <div class="document-name">{{ document.name }}</div>
                            <div class="document-size">{{ document.sizeFormatted || 'Available for download' }}</div>
                        </div>
                        <div class="document-actions">
                            <button class="btn view-btn" (click)="viewDocument(document)" [title]="'View ' + document.name">
                                <i class="fas fa-eye"></i>
                                View
                            </button>
                            <button class="btn download-btn" (click)="downloadDocument(document)" [title]="'Download ' + document.name">
                                <i class="fas fa-download"></i>
                                Download
                            </button>
                        </div>
                    </div>
                </div>
                <div class="no-documents" *ngIf="!prDetails || !prDetails.documents || prDetails.documents.length === 0">
                    <p>No documents available</p>
                </div>
            </div>

            <!-- Footer -->
            <div class="dialog-footer">
                <button class="btn close-button" (click)="closeDocumentsDialog()">Close</button>
            </div>
        </div>
    </div>
</div>

